import { render, staticRenderFns } from "./TransferToBankAcknowledgement.vue?vue&type=template&id=7edf4a71&"
import script from "./TransferToBankAcknowledgement.vue?vue&type=script&lang=js&"
export * from "./TransferToBankAcknowledgement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports